import React, { useState } from "react";
import { Modal, Table, Button, Form, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import api from "../../../../utils/api";
import { FaRegImage } from "react-icons/fa";
import { AiOutlineFilePdf } from "react-icons/ai";

const NomineeOptModal = ({
  show,
  onHide,
  clientData,
  nomineeOptModalData = [],
  proceedGoalEvent,
  roomId,
}) => {
  const [uploadingId, setUploadingId] = useState(null);
  const [files, setFiles] = useState({}); // store file per row
  const [isDownloading, setIsDownloading] = useState("");

  const [uploadedFiles, setUploadedFiles] = useState({});

  const [uploadedRefs, setUploadedRefs] = useState([]);
  // [{ client_id, client_code, ref_no }]

  const [showOtpBox, setShowOtpBox] = useState(false);
  const [otp, setOtp] = useState("");
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);


  /** 📂 Handle file select */
  const handleFileChange = (e, row) => {
    const selected = e.target.files[0];
    if (!selected) return;

    setFiles((prev) => ({
      ...prev,
      [row._id]: selected,
    }));
  };

  /** ⬆ Upload File */
  const uploadToServer = async (row) => {
    const file = files[row._id];
    if (!file) {
      Swal.fire("Error", "Please select a file first", "warning");
      return;
    }

    try {
      setUploadingId(row._id);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("client_id", row._id);
      formData.append("client_code", row.client_code);
      formData.append("ref_number", row.nominee_1_relationship);
      formData.append("otp", 123456);

      const response = await api.post(
        "advisor/create-nominee-reference",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      const { client_id, ref_no, file_path } = response.data.data;


      setUploadedFiles((prev) => ({
        ...prev,
        [client_id]: {
          file_path,
          ref_no,
        },
      }));
      // ✅ Store reference safely (avoid duplicates)
      setUploadedRefs((prev) => {
        const exists = prev.find((p) => p.client_id === client_id);
        if (exists) return prev;

        return [
          ...prev,
          {
            client_id,
            ClientCode: row.client_code,
            ref_number: ref_no,
          },
        ];
      });

      Swal.fire("Uploaded!", "Document uploaded successfully", "success");
    } catch (err) {
      console.error(err);
      Swal.fire("Upload Failed", "Something went wrong", "error");
    } finally {
      setUploadingId(null);
    }
  };


  const DownloadNominiesPdf = async (nomineeData, id) => {
    setIsDownloading(id)
    console.log("nomineeData", nomineeData)
    try {
      const response = await api.post(
        "advisor/downloadNominiesPdf",
        { nomineeData: [nomineeData] },
        {
          responseType: "blob", // 🔥 VERY IMPORTANT
          timeout: 0,
        }
      );

      // create blob
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      // create download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Nomination_Declaration.pdf";

      document.body.appendChild(a);
      a.click();

      // cleanup
      a.remove();
      setIsDownloading("")
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("PDF download error:", err);
      setIsDownloading("")
    }
  };

  const sendOtp = async () => {
    try {
      setIsSendingOtp(true);

      await api.post("advisor/send-otp", {
        mobile: clientData?.mobile, 
      });

      setShowOtpBox(true);

      Swal.fire("OTP Sent", "Please enter OTP to verify", "success");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to send OTP", "error");
    } finally {
      setIsSendingOtp(false);
    }
  };

  const verifyOtp = async () => {
    try {
      setIsVerifyingOtp(true);

      const response = await api.post("advisor/register-nominee-opt-no", {
        otp,
        client_id: roomId,
        clientss: uploadedRefs,
      });

      // 🔥 IMPORTANT CHECK
      if (response?.data?.status === "success") {
        Swal.fire("Success", "Nominee verification completed", "success");

        setShowOtpBox(false);
        setOtp("");
        setUploadedRefs([]);
        proceedGoalEvent();
        onHide();
      } else {
        // ❌ Business error (OTP expired, invalid, etc.)
        Swal.fire(
          "Verification Failed",
          response?.data?.message || "Invalid OTP",
          "error"
        );
      }
    } catch (err) {
      // ❌ Network / server crash
      console.error(err);
      Swal.fire(
        "Error",
        "Something went wrong. Please try again.",
        "error"
      );
    } finally {
      setIsVerifyingOtp(false);
    }
  };




  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton style={{ backgroundColor: "#c7e69b" }}>
        <Modal.Title>Update Nominee Opt Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3 p-2 bg-light ">
          <strong>Download Declaration Document</strong>
        </div>

        {/* 📊 Table */}
        <Table bordered hover responsive>
          <thead className="table-success">
            <tr>
              <th>Client Code</th>
              <th>Nominee Name</th>
              <th>Download Declaration Document </th>
              <th>Upload Document</th>

              <th>Submit</th>
              <th>Uploaded File</th>
            </tr>
          </thead>
          <tbody>
            {nomineeOptModalData.map((row) => (
              <tr key={row._id}>
                <td>{row.client_code}</td>
                <td>{row.nominee_1_name}</td>
                <td className="text-center">
                  <Button
                    size="sm"
                    variant="outline-success"
                    disabled={isDownloading === row._id}
                    onClick={() => DownloadNominiesPdf(row.nominee_1_name, row._id)}
                    className="d-flex align-items-center justify-content-center gap-2"
                  >
                    {isDownloading === row._id ? (
                      <>
                        <Spinner
                          animation="border"
                          size="sm"
                          role="status"
                        />
                        Downloading
                      </>
                    ) : (
                      <>⬇ Download PDF</>
                    )}
                  </Button>
                </td>


                <td>
                  <Form.Control
                    type="file"
                    accept=".pdf,.jpg,.png"
                    onChange={(e) => handleFileChange(e, row)}
                  />
                </td>

                <td>
                  <Button
                    size="sm"
                    variant="success"
                    disabled={uploadingId === row._id}
                    className="d-flex align-items-center gap-2"
                    onClick={() => uploadToServer(row)}
                  >
                    {uploadingId === row._id ? (
                      <>
                        <Spinner animation="border" size="sm" />
                        Uploading
                      </>
                    ) : (

                      <>

                        {/* <FaRegImage size={22} className="me-2 text-light" /> */}
                        Upload
                      </>
                    )}
                  </Button>

                </td>
                <td className="text-center">
                  {uploadedFiles[row._id]?.file_path ? (
                    <a
                      href={uploadedFiles[row._id].file_path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm btn-outline-success"
                    >
                      <AiOutlineFilePdf size={22} className="me-2 text-danger" />  View
                    </a>
                  ) : (
                    <span >--</span>
                  )}
                </td>

              </tr>
            ))}

            {nomineeOptModalData.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center text-muted">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {uploadedRefs.length > 0 && (
          <div className="text-center mt-4">
            <Button
              variant="success"
              disabled={isSendingOtp}
              onClick={sendOtp}
            >
              {isSendingOtp ? "Sending OTP..." : "Send OTP"}
            </Button>
          </div>
        )}

        {showOtpBox && (
          <div className="mt-4 d-flex justify-content-center gap-3">
            <Form.Control
              style={{ maxWidth: "200px" }}

              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            <Button
              variant="success"
              disabled={isVerifyingOtp || otp.length < 4}
              onClick={verifyOtp}
            >
              {isVerifyingOtp ? "Verifying..." : "Verify OTP"}
            </Button>
          </div>
        )}


      </Modal.Body>
    </Modal>
  );
};

export default NomineeOptModal;
